import axios from "axios";
import { ADDERS_API, MAIN_URL } from "../../API/Api";

const GetAllAdders = async (data, token) => {
    let headers = {
        Accept: "application/json",
        token: `bL4r$a$c$e6JA8cU`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${ADDERS_API}`,
        headers: headers,
        params: { ...data },
    });

    return response.data;
};

const GetSingleAdder = async (data, token) => {
    let headers = {
        Accept: "application/json",
        token: `bL4r$a$c$e6JA8cU`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${ADDERS_API}/${data}`,
        headers: headers,
    });
    return response.data;
};

const CreateAdder = async (data, token) => {
    let headers = {
        Accept: "application/json",
        token: `bL4r$a$c$e6JA8cU`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${ADDERS_API}/store`,
        headers: headers,
        data,
    });
    return response.data;
};

const UpdateAdder = async (data, token) => {
    let headers = {
        Accept: "application/json",
        token: `bL4r$a$c$e6JA8cU`,
    };

    let response = await axios({
        method: "POST",
        baseURL: `${ADDERS_API}/update/${data.id}`,
        headers: headers,
        data,
    });
    return response.data;
};

const UpdateAdderStatus = async (id, token) => {
    let headers = {
        Accept: "application/json",
        token: `bL4r$a$c$e6JA8cU`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${ADDERS_API}/update-status/${id}`,
        headers: headers,
    });
    return response.data;
};

const DeleteAdder = async (id, token) => {
    let headers = {
        Accept: "application/json",
        token: `bL4r$a$c$e6JA8cU`,
    };
    let response = await axios({
        method: "DELETE",
        baseURL: `${ADDERS_API}/delete/${id}`,
        headers: headers,
    });
    return response.data;
};

const GetAllServiceTypes = async (token) => {
    let headers = {
        Accept: "application/json",
        authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${MAIN_URL}/services`,
        headers: headers,
    });
    caches.log(response.data);
    return response.data;
};

const AddersService = {
    GetAllAdders,
    GetSingleAdder,
    CreateAdder,
    UpdateAdder,
    UpdateAdderStatus,
    DeleteAdder,
    GetAllServiceTypes,
};

export default AddersService;
